module.exports = __webpack_public_path__ + "static/media/amz_FRONT_LEFT.e9e05fa4.svg";